let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("47Le8")).then(() => parcelRequire('5Ak4K'));